import { Filter } from 'bad-words';
import blockedWordsEn from '../data/blockedWordsEn';
import blockedWordsHi from '../data/blockedWordsHi';

// Sole dictionary: EN + HI lists only (no default bad-words list)
const blockedWords = Array.from(
  new Set(
    [...blockedWordsEn, ...blockedWordsHi]
      .map((word) => String(word).trim().toLowerCase())
      .filter(Boolean)
  )
);

// emptyList: true ignores constructor `list` — populate via addWords in chunks
const contentFilter = new Filter({ emptyList: true });
const ADD_CHUNK_SIZE = 400;
for (let i = 0; i < blockedWords.length; i += ADD_CHUNK_SIZE) {
  contentFilter.addWords(...blockedWords.slice(i, i + ADD_CHUNK_SIZE));
}

const MAX_MATCHES_DISPLAY = 8;

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Returns true when text contains a blocked EN/HI word (strict).
 * Empty / whitespace-only text is not blocked (caller handles empty).
 */
export const containsBlockedContent = (text) => {
  if (!text || !String(text).trim()) {
    return false;
  }
  return contentFilter.isProfane(String(text));
};

/**
 * Returns up to MAX_MATCHES_DISPLAY matched blocked tokens for the warning dialog.
 */
export const getBlockedMatches = (text) => {
  if (!text || !String(text).trim()) {
    return [];
  }

  const haystack = ` ${String(text).toLowerCase()} `;
  const matches = [];

  for (let i = 0; i < blockedWords.length; i += 1) {
    if (matches.length >= MAX_MATCHES_DISPLAY) {
      break;
    }
    const word = blockedWords[i];
    const re = new RegExp(`(^|[^a-z0-9])${escapeRegex(word)}([^a-z0-9]|$)`, 'i');
    if (re.test(haystack) && matches.indexOf(word) === -1) {
      matches.push(word);
    }
  }

  if (matches.length === 0 && contentFilter.isProfane(String(text))) {
    return ['prohibited language'];
  }

  return matches;
};

export default {
  containsBlockedContent,
  getBlockedMatches,
};
